import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { taskTypeGroupLabelStyles, taskTypeGroupListStyles } from './TaskTypeGroupLabel.styles';

const TaskTypeGroupLabel = ({ group, children }) => (
  <li>
    <Box sx={taskTypeGroupLabelStyles}>
      <Typography color="text.primary" variant="medium14">
        {group}
      </Typography>
    </Box>
    <Box component="ul" sx={taskTypeGroupListStyles}>
      {children}
    </Box>
  </li>
);

TaskTypeGroupLabel.propTypes = {
  group: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default memo(TaskTypeGroupLabel);
